import { Box, Button, Header, Modal } from "@amzn/awsui-components-react"
import { useProfile } from "context/ProfileContext"
import React, { useEffect } from "react"
import { useNavigate } from "react-router-dom"
import routes from "routes"

const ReleaseNoteModal: React.FC<{
  visible: boolean
}> = ({ visible }) => {
  const navigate = useNavigate()
  const { profileData, setNotesModal } = useProfile()

  const LAST_NOTES_KEY = "thunder.lastNotesSeen"
  const LAST_NOTES_DATE = "5-23-2024"
  const lastNotesSeen = localStorage.getItem(LAST_NOTES_KEY)

  useEffect(() => {
    if (lastNotesSeen != LAST_NOTES_DATE && profileData?.seeReleaseNotes == true) setNotesModal(true)
  }, [lastNotesSeen, profileData, setNotesModal])

  return (
    <Modal
      visible={visible}
      onDismiss={() => {}}
      header={<Header variant="h1">{`Thunder Release Notes for ${LAST_NOTES_DATE}`}</Header>}
      footer={
        <Box float="right">
          <Button
            variant="primary"
            onClick={() => {
              localStorage.setItem(LAST_NOTES_KEY, LAST_NOTES_DATE)
              navigate(routes.profile)
              setNotesModal(false)
            }}
          >
            Dismiss
          </Button>
        </Box>
      }
    >
      <div>
        {/* put patch notes here */}
        <h3>Adding Task to Account</h3>
        <p>You are now able to add Task against Account. Navigate to Search, and select Search Accounts to find and select an Account to add your task.</p>
        {/* put patch notes here ^^^ */}
      </div>
      <p>
        {"You can check our previous release notes on the "}
        <a target="_blank" rel="noopener noreferrer" href="https://w.amazon.com/bin/view/AWS/Teams/PartnerSA/Thunder/ReleaseNotes/">
          Thunder wiki
        </a>
        .
      </p>
    </Modal>
  )
}

export default ReleaseNoteModal
